/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import "vuetify/styles";
import { soStromThemeConfig } from '@es-bill/es-bill-common-components'
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import { de } from 'vuetify/locale';
import type { App } from 'vue';

/**
 * Register all application plugins
 */
export function registerPlugins(app: App): void {
  /// VUETIFY
  const vuetify = createVuetify({
    locale: {
      locale: 'de',
      messages: { de },
    },
   ...soStromThemeConfig
  });

  app.use(vuetify);
}